import { render, staticRenderFns } from "./safari.vue?vue&type=template&id=60d78f55&lang=html&"
import script from "./safari.vue?vue&type=script&lang=js&"
export * from "./safari.vue?vue&type=script&lang=js&"
import style0 from "./safari.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "safari.vue"
export default component.exports